var Shopify = Shopify || {}
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}'
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

const selectors = {
  bundleItems: '.bundle-item-container',
  productWrapper: '#bundle-product',
  itemsWrapper: '.bundle-items',
  itemEmptyState: '[data-hook="empty"]',
  itemFilledState: '[data-hook="filled"]',
  itemTitle: '[data-hook="title"]',
  itemSize: '[data-hook="size"]',
  itemPrice: '[data-hook="price"]',
  itemImage: '[data-hook="image"]',
  strikethroughPrice: '[data-hook="bundle-strikethrough-price"]',
  price: '[data-hook="bundle-price"]',
  discountMessage: '[data-hook="bundle-discount"]',
  atcButton: '[data-hook="bundle-atc"]',
  addMessage: '[data-hook="add-more-message"]',
  giftMessage: '[data-hook="gift-message"]',
  itemCount: '[data-hook="item-count"]',
}

const classes = {
  active: 'on',
}

let items = []
const maxItemCount = 8

let selectionType = { amount: 9 }

let discountTiers = {
  1: 0,
  2: 0,
  3: 100,
  4: 200,
  5: 400,
  6: 600,
  7: 900,
  8: 1200,
  9: 2000,
}

const percentTiers = {
  1: 0,
  2: 0,
  3: 0,
  4: 5,
  5: 5,
  6: 10,
  7: 10,
  8: 10,
}

const BUNDLE_SELECTORS = {
  price: '.bundle-price',
  prevPrice: '.bundle-prev-price',
  discountPrice: '.bundle-discount-price',
}

let cartFullPrice = () => items.reduce((acc, item) => acc + parseInt(item.price), 0)

let cartTotal = () => items.reduce((acc, item) => acc + parseInt(item.price), 0) - cartDiscount()

let cartOriginalTotal = 0
let cartDiscount = () => discountTiers[items.length]

const clearAllBundles = () => {
  // console.log('clearAllBundles')

  const bundleItems = document.querySelectorAll(selectors.bundleItems)
  bundleItems.forEach((item, index) => {
    // if it's a extra cloned node, remove it
    if (!items[index] && index + 1 > maxItemCount) {
      item.remove()
    }

    item.classList.remove(classes.active)

    const itemImage = item.querySelector(selectors.itemImage)
    const itemTitle = item.querySelector(selectors.itemTitle)
    const itemSize = item.querySelector(selectors.itemSize)
    const itemPrice = item.querySelector(selectors.itemPrice)

    itemImage.src = ''
    itemTitle.innerText = ''
    itemSize.innerText = ''
    itemPrice.innerText = ''
  })
}

const saveState = () => {
  const itemStorageData = JSON.stringify(items)
  sessionStorage.setItem('churn-bundle-items', itemStorageData)
}

const loadState = () => {
  const itemStorageData = sessionStorage.getItem('churn-bundle-items')

  if (itemStorageData) {
    items = JSON.parse(itemStorageData)
    loadItems()
  }
}

const updateATCButton = () => {
  const atcButtonList = document.querySelectorAll(selectors.atcButton)

  atcButtonList.forEach((button) => {
    if (items.length > 0) {
      button.removeAttribute('disabled')
    } else {
      button.setAttribute('disabled', 'disabled')
    }
  })
}

const loadItems = () => {
  clearAllBundles()
  updateATCButton()

  const itemsWrapper = document.querySelector(selectors.itemsWrapper)
  const bundlePriceEl = document.querySelectorAll(BUNDLE_SELECTORS.price)
  const prevPrice = document.querySelectorAll(BUNDLE_SELECTORS.prevPrice)
  const discountPrice = document.querySelectorAll(BUNDLE_SELECTORS.discountPrice)
  const strikeWrapper = document.querySelectorAll('.bundle-strike')

  let html = ''

  // Max length is 9, only loop at most 9 times
  // // const maxLength = items.length > 9 ? 9 : items.length
  // const maxLength = Math.min(items.length, 9)
  const maxLength = items.length

  for (let i = 0; i < maxLength; i++) {
    let item = document.querySelector(selectors.bundleItems + `[data-index="${i + 1}"]`)
    const itemData = items[i]

    if (!item) {
      const clonedItem = document.querySelector(selectors.bundleItems)
      item = clonedItem.cloneNode(true)
      const removeButton = item.querySelector('.bundle-item-remove')

      item.dataset.index = i + 1
      // different index for remove button
      removeButton.dataset.index = i

      // bundle-items
      if (itemsWrapper) {
        itemsWrapper.append(item)
      }
    }

    const itemImage = item.querySelector(selectors.itemImage)
    const itemTitle = item.querySelector(selectors.itemTitle)
    const itemSize = item.querySelector(selectors.itemSize)
    const itemPrice = item.querySelector(selectors.itemPrice)
    const itemInput = item.querySelector('input')

    itemImage.src = itemData.image
    itemTitle.innerText = itemData.title
    itemSize.innerText = itemData.options
    itemPrice.innerText = Shopify.formatMoney(itemData.price, Shopify.money_format)
    itemInput.value = itemData.id
    itemInput.name = `items[${i}][id]`

    item.classList.add(classes.active)
  }

  if (items.length < selectionType.amount) {
    document.querySelector('.bundle-message').classList.remove('hidden')
    bundlePriceEl.forEach((price) => price.classList.remove('visible'))

    for (let j = items.length; j < selectionType.amount; j++) {
      html += `<div class="bundle-item">
                        <div class="bundle-add-icon">+</div>
                    </div>`
    }
  } else {
    bundlePriceEl.forEach((price) => price.classList.add('visible'))

    let sum = 0
    for (let i = 0; i < items.length; i++) {
      sum += parseInt(items[i].price)
    }
    prevPrice.forEach((price) => (price.innerText = '$' + sum.toFixed(2)))
    discountPrice.forEach((price) => (price.innerText = '$' + (sum * (1 - selectionType.discount / 100)).toFixed(2)))
  }

  // * Update item count
  const itemCount = document.querySelector(selectors.itemCount)

  itemCount.innerText = `(${items.length})`

  if (items.length > 0) {
    itemCount.classList.add(classes.active)
  } else {
    itemCount.classList.remove(classes.active)
  }

  // * Calculate Updated Pricing

  const maxPercentOff = percentTiers[Object.keys(percentTiers).length]

  let percentOff = percentTiers[items.length]
  if (items.length == 0) {
    percentOff = 0
  } else if (percentTiers[items.length] == undefined) {
    percentOff = maxPercentOff
  }

  const totalPrice = items.reduce((acc, item) => acc + parseInt(item.price), 0)
  const priceAfterDiscount = totalPrice * ((100 - percentOff) / 100)

  // * Update Strikethrough Price

  const strikethroughPriceList = document.querySelectorAll(selectors.strikethroughPrice)
  const fullPrice = Shopify.formatMoney(cartFullPrice(), Shopify.money_format)

  if (totalPrice > priceAfterDiscount) {
    // Update strikethrough price
    strikethroughPriceList.forEach((strikethroughPrice) => {
      strikethroughPrice.innerText = fullPrice
    })
  } else {
    // Remove strikethrough price
    strikethroughPriceList.forEach((strikethroughPrice) => {
      strikethroughPrice.innerText = ''
    })
  }

  // * Update Price

  const priceList = document.querySelectorAll(selectors.price)

  priceList.forEach((price) => {
    if (priceAfterDiscount == 0) {
      price.innerText = '$0'
    } else {
      price.innerText = Shopify.formatMoney(priceAfterDiscount, Shopify.money_format)
    }
  })

  // * Update Discount Message

  const discountMessageList = document.querySelectorAll(selectors.discountMessage)

  discountMessageList.forEach((message) => {
    if (percentOff > 0) {
      message.innerText = `${percentOff}% Off`
    } else {
      message.innerText = ''
    }
  })

  // * Update Gift Message

  const giftMessage = document.querySelector(selectors.giftMessage)
  const giftThreshold = 8

  if (items.length >= giftThreshold) {
    giftMessage.classList.add(classes.active)
  } else {
    giftMessage.classList.remove(classes.active)
  }

  ////

  discountPrice.forEach((price) => (price.innerText = Shopify.formatMoney(cartTotal(), Shopify.money_format)))

  if (cartDiscount > 0) {
    strikeWrapper.forEach((el) => {
      el.style.setProperty('display', 'flex')

      el.style.setProperty('display', 'flex')
      el.querySelector('.bundle-strike-message').innerHTML = `${Shopify.formatMoney(
        cartDiscount,
        Shopify.money_format
      )} Off`
      el.querySelector('.bundle-prev-price').innerHTML = `${Shopify.formatMoney(
        cartOriginalTotal,
        Shopify.money_format
      )}`
    })
    prevPrice.forEach((el) => (el.innerHTML = `${Shopify.formatMoney(cartOriginalTotal, Shopify.money_format)}`))
  } else {
    strikeWrapper.forEach((el) => el.style.setProperty('display', 'none'))
  }

  document.querySelectorAll('.bundle-progress-bar').forEach((progressBar) => {
    progressBar.style.setProperty('--progress', `${(items.length / selectionType.amount) * 100}%`)
  })

  discountPrice.forEach((price) => (price.innerText = Shopify.formatMoney(cartTotal(), Shopify.money_format)))

  // * Show/Hide "Add More" message

  const addMessage = document.querySelector(selectors.addMessage)

  if (items.length < maxItemCount) {
    addMessage.classList.remove(classes.active)
  } else {
    addMessage.classList.add(classes.active)
  }
}

const getProductFromData = (el) => ({
  id: el.getAttribute('data-id'),
  image: el.getAttribute('data-image'),
  price: el.getAttribute('data-price'),
  title: el.getAttribute('data-title'),
  quantity: el.querySelector('[name*="product_quantity"]').value,
  options: el.getAttribute('data-options'),
})

const addItem = (e) => {
  // console.log('addItem')

  const parent = e.target.parentElement
  const container = parent.closest('.product-item')
  const productData = getProductFromData(container)

  for (let i = 0; i < productData.quantity; i++) {
    items.push(productData)
  }

  saveState()
  loadItems()
}
const removeItem = (index) => {
  // console.log('removeItem')

  items.splice(index, 1)

  saveState()
  loadItems()

  // console.log({ items: JSON.parse(JSON.stringify(items)) }, 'before')
}

document.querySelectorAll('.bundle-add').forEach((button) => button.addEventListener('click', addItem))

const updateTypeSelection = (index, type) => {
  // console.log('updateTypeSelection')

  document.querySelectorAll('.bundle-amount-select').forEach((selector, selectorIndex) => {
    if (selectorIndex === index) {
      selector.classList.add('selected')
    } else {
      selector.classList.remove('selected')
    }
  })

  if (items.length > type.amount) {
    items.splice(type.amount)
  }

  loadItems()
}

const getCart = async (productData) => {
  // console.log('getCart')

  const cartResponse = await fetch('/cart.js')
  if (cartResponse.ok) {
    const cartData = await cartResponse.json()
    items = cartData.items.flatMap((item) => {
      const product = productData[item.id]
      return Array.from({ length: item.quantity }, () => ({
        id: item.id,
        image: product.image,
        price: item.price,
        title: product.title,
      }))
    })
    cartTotal = cartData.total_price
    cartOriginalTotal = cartData.original_total_price
    cartDiscount = cartData.total_discount
    loadItems()
    return cartData
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  loadState()

  // Disable the ATC button when unavailable options are selected
  document.querySelectorAll(selectors.productWrapper).forEach((productWrapper) => {
    const select = productWrapper.querySelector('select')

    select.addEventListener('change', (e) => {
      select.querySelectorAll('option').forEach((option) => {
        if (select.value != option.value) return

        const atcButton = productWrapper.querySelector('.bundle-add')

        if (option.innerText.toLowerCase().includes('unavailable')) {
          atcButton.setAttribute('disabled', 'disabled')
        } else {
          atcButton.removeAttribute('disabled')
        }
      })
    })
  })

  document.querySelectorAll('.product-quantity--add').forEach((el) => {
    // console.log('finding el?')
    el.addEventListener('click', (el) => {
      const qty = el.target.parentElement.querySelector('input')
      // console.log({ qty })
      qty.value = parseInt(qty.value) + 1
    })
  })

  document.querySelectorAll('.product-quantity--remove').forEach((el) => {
    el.addEventListener('click', (el) => {
      const qty = el.target.parentElement.querySelector('input')
      if (parseInt(qty.value) > 1) {
        qty.value = parseInt(qty.value) - 1
      }
    })
  })

  // Remove Item Event Listeners
  document.querySelector('.bundle-items').addEventListener('click', function (event) {
    const el = event.target

    if (el.classList.contains('bundle-item-remove')) {
      removeItem(el.getAttribute('data-index'))

      // do our newly items hae data-index??

      // if it's a cloned node just remove it entirely
    }
  })

  const cartDrawer = document.querySelector('cart-drawer')
  atcButtons = document.querySelectorAll('.bundle-atc-button')
  atcButtons.forEach((button) => {
    button.addEventListener('click', (ev) => {
      const form = ev.target.closest('form')
      const formData = new FormData(form)
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      )
      formData.append('sections_url', window.location.pathname)
      cartDrawer.setActiveElement(document.activeElement)

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          console.log({ res, t: typeof res })
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: res })
          cartDrawer.renderContents({
            id: res.id,
            sections: res.sections,
          })

          items = []

          saveState()
          loadItems()
        })
        .finally(() => {
          if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty')
          }
        })
    })
  })
})

// TODO: Add Qty minimum
// TODO: Add theme editor options
// TODO: Restyle minicart
